module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/aff9524c78dd205f02a614937102c5ee.gif";